import Header from './header.connect'

export default Header



// WEBPACK FOOTER //
// ./src/components/common/header/index.js